import { openModal } from 'helpers/dom'
import ProductVendorModal from 'modules/product-vendor/product-vendor-modal'
import Image from 'snippets/image/image'
import Icon from 'snippets/icon/icon'

export default function ProductLookBook() {
  return lookSettings.imageUrl.length > 0 && (
    <>
      <div className="cursor-zoom-in select-none relative block aspect-[1/1] w-full">
        <Image
          imageUrl={lookSettings.imageUrl}
          alt={lookSettings.heading}
          className="aspect-[1/1] w-full"
          imageClass="w-full h-full"
          imageBreakpoints="(min-width: 768px)|(min-width: 0px)"
          isCover={false}
          isLazy={true}
        />
      </div>
      {lookSettings.products.length > 0 ? (
        <button type="button" class="flex items-center gap-2 absolute z-10 bottom-8 left-6 whitespace-nowrap button-primary bg-black/40 text-xs md:bottom-6" title="show lookbook modal" aria-label="show lookbook modal"
          onClick={(e) => {
            e.stopPropagation()
            openModal('product-lookbook-modal')
          }}
        >
          <Icon name="icon-shopping-bag-simple" className="w-5 h-5 text-white" />
          {lookSettings.heading}
        </button>) : ''}
    </>
  )
}
